import {
  Train,
  CalendarDays,
  Users,
  ShieldCheck,
  MessageSquare,
  MapPin,
  Bell,
  Plane
} from 'lucide-react';

const UTILITY_ICONS = {
  Train: <Train size={14} className="text-slate-600" />,
  CalendarDays: <CalendarDays size={14} className="text-slate-600" />,
  Users: <Users size={14} className="text-slate-600" />,
  ShieldCheck: <ShieldCheck size={14} className="text-slate-600" />,
  MessageSquare: <MessageSquare size={14} className="text-slate-600" />,
  MapPin: <MapPin size={14} className="text-slate-600" />,
  Bell: <Bell size={14} className="text-slate-600" />,
  Plane: <Plane size={14} className="text-slate-600" />
};

const InTripUtilities = ({ utilities = [] }) => {
  return (
    <div className="mt-5 sm:mt-7 pt-4 sm:pt-6 border-t border-slate-100">
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 sm:gap-2.5">
        {utilities.map((util) => {
          const icon = typeof util.icon === 'string' ? UTILITY_ICONS[util.icon] : util.icon;

          return (
            <div
              key={util.id}
              className="flex items-center gap-2.5 px-3 py-2.5 rounded-xl bg-slate-50/70 hover:bg-[#eaf8f7]/40 border border-slate-200/70 hover:border-primary/40 hover:shadow-2xs transition-all duration-200 group cursor-default"
            >
              <div className="w-7 h-7 rounded-lg bg-white shadow-2xs border border-slate-100 flex items-center justify-center shrink-0 text-slate-500 group-hover:text-primary group-hover:scale-105 transition-all">
                {icon}
              </div>
              <span className="text-xs font-medium text-slate-700 group-hover:text-slate-900 leading-tight">
                {util.label}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default InTripUtilities;
